import PiggyBankIcon from '@/components/widget/PiggyBankIcon';
export default {
  name: 'Info',
  components: {
    PiggyBankIcon
  },
  props: {
    subscriptiontype: Object
  },
  data: () => {
    return {
      openModal: false
    };
  },
  filters: {
    billingType: function (value) {
      return value > 1 ? 'Annually' : value ? 'Monthly' : 'Once';
    }
  }
};